import {getAmountToQuantityMap} from './lift-lead-options'
const currencyCodes = {
  US: 'USD',
  BB: 'USD',
  KY: 'USD',
  CA: 'CAD',
  AU: 'AUD',
  GB: 'GBP',
  NZ: 'NZD',
  ES: 'USD',
  IT: 'USD',
  IN: 'USD',
  PH: 'USD',
  VN: 'USD',
  GR: 'USD',
}

const ccCurrencyCodes = {
  US: 'USD',
  BB: 'BBD',
  KY: 'KYD',
  CA: 'CAD',
  AU: 'AUD',
  NZ: 'NZD',
  GB: 'GBP',
  ES: 'USD',
  IT: 'USD',
  IN: 'USD',
  PH: 'USD',
  VN: 'USD',
  GR: 'USD',
}

const resolveIsoCountry = country => {
  if (typeof country !== 'string' || !country) return 'US'
  const trimmed = country.trim()
  if (/^[A-Za-z]{2}$/.test(trimmed)) return trimmed.toUpperCase()
  return countryValueToIso[trimmed.toLowerCase()] || 'US'
}

const countryValueToIso = {
  usa: 'US',
  aus: 'AU',
  cayman: 'KY',
  barbados: 'BB',
  can: 'CA',
  nz: 'NZ',
  gb: 'GB',
  spain: 'ES',
  italy: 'IT',
  india: 'IN',
  philippines: 'PH',
  vietnam: 'VN',
  greece: 'GR',
}

const currencyFormat = (price, country, isCcOrder) => {
  const isoCountry = resolveIsoCountry(country)
  const currencyMap = isCcOrder ? ccCurrencyCodes : currencyCodes
  const currency = currencyMap[isoCountry] || 'USD'
  // For countries not explicitly in the currency map the currency falls back
  // to USD — use the US locale so formatting matches US display conventions
  // (e.g. "$399.00") rather than the country's own locale conventions.
  const locale = currencyMap[isoCountry] ? `en-${isoCountry}` : 'en-US'
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(price)
  } catch (err) {
    console.error(
      `[currencyFormat] Invalid locale/currency, falling back to USD. locale=${locale} currency=${currency} country=${country}`,
      err,
    )
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price)
  }
}

const formatPrice = (
  amount,
  quantity = 1,
  title = '',
  country = 'US',
  isCcOrder = false,
) => {
  const normalizedTitle = String(title || '')
    .trim()
    .toLowerCase()
  const isSeoTitle = normalizedTitle.includes('seo')
  const isSeoTitleWithQuantity = [
    'aeo & seo',
    'seo keywords',
    'aeo & seo powerboost',
  ].includes(normalizedTitle)
  if (Number.isNaN(amount)) {
    if (typeof amount === 'string') return amount
  }
  if (amount === 'To be calculated') {
    return amount
  }
  if (
    (isSeoTitle && !isSeoTitleWithQuantity) ||
    title.includes('Thryv Leads') ||
    title.includes('Workforce Center Employees') ||
    title.includes('Workforce Center Contractors')
  ) {
    quantity = 1
  }

  if (amount === undefined) {
    return ''
  }
  if (title.includes('Leads Lift') && !title.includes('Leads Lift BNI')) {
    const entries = Object.entries(getAmountToQuantityMap(country))
    const closest = entries.reduce((prev, curr) =>
      Math.abs(curr[1] - quantity) < Math.abs(prev[1] - quantity) ? curr : prev,
    )
    const priceLL = Number(closest[0])
    return `$${priceLL.toFixed(2)}`
  }
  // if (amount < 0) {
  //   // return `-$${(amount * quantity * -1).toFixed(2)}`
  //   // return `${currencyFormat()}`

  //   return `${currencyFormat(amount * quantity, country)}`
  // }
  // return `$${(amount * quantity).toFixed(2)}`
  return `${currencyFormat(amount * quantity, country, isCcOrder)}`
}

export {currencyFormat, formatPrice}
